var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJquery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1918;}\r\n\t.st1{fill:#21609B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M417.2,214.7l15.3,0.1c0,0-28.5,38.6-30.8,41.8c-0.8,1-1.9,2.1-2.5,3.5c-1.5,3.4-3,10.9-3,10.9 l-14,0.1c0,0,2.2-7.8,2.1-12c-0.1-3.6-1.9-7.3-3-10.9c-1.1-3.7-2.5-10.9-2.5-10.9h14.4l2,8L417.2,214.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M388.2,222.8c2.8,1.7,4.6,11.1,4.6,11.1s-14.8,0.2-22.9,0.2h-7l-8.5,36.8h-12.9 c0,0,8-40,9.9-47.2c0.6-2.3,4.2-1.9,10.3-1.9h9.7C377.7,221.7,385.1,220.9,388.2,222.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M328,240.7c0,0,0.4-2.4-1.4-5.1c-1.5-2.3-2.9-2.9-6.9-3c-11.2-0.4-11,8-11,8L328,240.7z  M340.2,231.2c1.6,5.9-1.5,19.9-1.5,19.9s-16.4-0.3-25.4,0c-2.8,0.1-6.1-0.3-7,1c-1.2,1.8,0.4,4.6,1.8,5.8c1.6,1.4,4.6,1.5,5.7,1.7 c7.3,0.9,22.5,0.2,22.5,0.2l-2.6,11.7c0,0-21.5,1.1-32.3-1.5c-2.1-0.5-4.1-1.5-5.5-3c-0.4-0.4-0.7-0.9-1-1.4 c-0.3-0.4-1.1-1.6-1.5-2.6c-2.5-6.6,0.3-19.1,3-25.8c0.3-0.8,0.7-1.8,1.1-2.6c0.5-1,1-2.2,1.4-2.9c0.3-0.4,0.6-0.7,0.9-1.1 c0.3-0.5,0.7-0.9,1.1-1.4c1-1.2,2.1-2,3.5-3c4.5-3.4,12.6-6,22.4-5c3.7,0.4,9.2,1.7,11.9,5.5C339.4,227.7,339.8,229.7,340.2,231.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M280.9,221.7l12.5-0.1c0,0-7,33.1-10.5,49.3h-14.4c-10.1,0-19,1.2-22.9-6 c-3.7-7-0.2-18.5,1.5-26.3c1.2-5.5,3.6-16.9,3.6-16.9l13-0.1c0,0-3.7,17.6-5.2,26.4c-0.5,3.2-1.7,6.1-0.5,8.5 c1.1,2.2,2.7,2.4,7.5,2.5c1.5,0,6.5,0,6.5,0L280.9,221.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M222.2,245.6c1.3-4.7,3.2-9.7,3-13.9c-0.3-4.5-4-8.6-6.5-9.4c-7.3-2.6-14.2,1-16.9,4 c-3.5,3.8-4.7,8.3-6,14.4c-0.9,4.6-1.7,9.4,0,12.9c3,6.3,12.3,4.9,22.4,5C219.7,254.5,221,250,222.2,245.6z M239.6,227.2 c1.4,10.4-4.1,21.9-7.8,31.9c3.9,0.3,7.2-0.1,7.5,0.2c0.3,0.4-2.6,11.9-3.6,12c-3.1,0.1-13.2,0.2-17.4,0.2c-13.8,0-26.7,0.9-33.3-6 c-2.7-2.8-4.5-7.6-5-10.9c-0.7-5.6,0.2-11.8,1.5-16.9c1.2-4.6,2.7-8.9,5-12.9c5.8-10.1,15.9-17.6,32.8-15.9c3.3,0.3,8,1.8,10.9,3.5 c0.2,0.1,0.9,0.7,1.1,0.8C235.2,215.6,238.9,221.6,239.6,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M178.5,221.8c-0.8,3.8-1.7,8.1-2.6,11.9h-13.9c1.1-4.2,1.9-8.3,3-11.9 C169.5,221.7,173.7,221.8,178.5,221.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M161.6,237.1H175c-1.8,9.7-5.2,25.4-8,36.3c-1.7,6.8-2.8,11.8-7.5,15.4c-0.4,0.3-0.7,0.2-1,0.5 c-0.9,0.8-4.8,1.8-7,2c-3.5,0.4-7.5,0-11.9,0c1.1-4.2,2.4-9.2,3.4-12.9c10.6,1.3,10.9-8.7,12.9-18.4 C157.3,254.4,160.9,239.3,161.6,237.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st1",
    d: "M130.3,262.5l-0.3,0.7c-4.9,9.5-13.6,15.4-26,15.7c-5.8,0.1-11.3-1.4-14.9-3 c-7.8-3.5-14.3-10-17.9-16.9c-5.1-9.9-6-23.7,4.6-34.1c0.2,0-1.3,2.2-1.1,2.2l-0.3,1c-7.7,24,16,44.6,39,42.3 C118.9,269.8,125.9,266.8,130.3,262.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st1",
    d: "M116.3,252.5c5.8,0,11.8-2.7,15.4-6.5c-3.1,7.9-12.2,13.1-24.4,11.4 c-10.2-1.4-19.9-11.6-20.9-21.9c-0.7-7.5,1.9-11.9,6.2-17.3c-1.5,2.8-2,5-2.2,6.4C88.9,240.8,103.4,252.4,116.3,252.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st1",
    d: "M131.2,232.4c-0.9,2.1-6.1,6-8.4,6.4c-9.1,1.9-14.9-2.4-17.9-7.3c-0.5-0.7-1.3-2.7-1.4-3.2 c-1.2-4-0.6-10.1,2.9-13.2c-1.1,3-1.2,6.4-0.7,8.7c0.3,1.4,1.4,3.7,2.4,5.2c1.9,2.7,3.1,3.4,5.5,4.8c1.1,0.7,2.2,1.2,2.7,1.3 C118.6,236,123.4,237.7,131.2,232.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJquery);
export default __webpack_public_path__ + "static/media/jquery.087fc9badba19875e5e8769735aecabe.svg";
export { ForwardRef as ReactComponent };